import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom"; // Import useNavigate from react-router-dom
import { getBaseUrl } from "../../utils";

const LoginThreeOtp = ({ nextStep, prevStep, handleFormData, values }) => {
    const baseUrl = getBaseUrl();

    const [otp, setOtp] = useState();
    const [verified, setVerified] = useState(false);
    const [otpVal, setOtpVal] = useState([]);
    const textBase = useRef(null);
    const [resendTimer, setResendTimer] = useState(30); // Timer for resend OTP

    const navigate = useNavigate(); // Initialize navigate
    useEffect(() => {
        const token = localStorage.getItem("userToken");
        if (token) {
            navigate("/dashboard"); // Redirect to dashboard if token exists
        }
    }, [navigate]);

    useEffect(() => {
        setOtp(Math.floor(1000 + Math.random() * 9000)); // Generate OTP on first render
    }, []);

    useEffect(() => {
        if (resendTimer > 0) {
            const timer = setInterval(() => {
                setResendTimer((prev) => prev - 1);
            }, 1000);
            return () => clearInterval(timer);
        }
    }, [resendTimer]);

    const clearAll = () => {
        textBase.current.classList.remove("otp-error");
        textBase.current.childNodes.forEach((child) => {
            child.value = "";
        });
        setOtpVal([]);
        setVerified(false);
    };

    const getOtp = () => {
        // Only check if OTP fields are not empty
        if (otpVal.length === 6 && parseInt(otpVal.join("")) === otp) {
            textBase.current.classList.remove("otp-error");
            setVerified(true); // Set verified to true if OTP is correct
        } else {
            textBase.current.classList.add("otp-error");
            setVerified(false); // Reset verified to false if OTP is incorrect
        }
    };

    const focusNext = (e) => {
        const childCount = textBase.current.childElementCount;
        const currentIndex = [...e.target.parentNode.children].indexOf(e.target);

        if (e.key === "Backspace") {
            if (!e.target.value && currentIndex > 0) {
                const prevInput = e.target.previousSibling;
                prevInput.focus();
                prevInput.value = "";
            }
        } else if (e.target.value && currentIndex < childCount - 1) {
            e.target.nextSibling.focus();
        }

        const values_1 = Array.from(textBase.current.childNodes).map((child) => child.value);
        setOtpVal(values_1);
        handleFormData({ ...values, otp: values_1.join("") });
    };

    useEffect(() => {
        if (otpVal.length === textBase.current.childElementCount) {
            getOtp(); // Check if OTP is correct once all fields are filled
        }
    }, [otpVal]);

    const handleNextStep = async (e) => {
        e.preventDefault();
        if (otpVal.length !== 6 || !otpVal.join("")) {
            alert("Please enter a valid OTP.");
            return;
        }
        try {
            const response = await axios.post(
                baseUrl + "user_api/userAuthentication",
                {
                    number: values.phone,
                    otp: otpVal.join(""),
                    deviceType: "WEB",
                    deviceID: "unique_device_id",
                    deviceToken: "token_here",
                }
            );

            if (response.data.status) {
                localStorage.setItem("userToken", response.data.token);
                alert("OTP verified successfully!");
                var results = response.data.results;
                if (!results.name) {
                    navigate("/signup");
                } else {
                    navigate("/Dashboard");
                }
            } else {
                alert("OTP verification failed. Please try again.");
            }
        } catch (error) {
            alert("An error occurred. Please try again later.");
        }
    };

    const handlePrevStep = () => {
        prevStep();
    };

    const resendOtp = async () => {
        try {
            const response = await axios.post(
                baseUrl + "user_api/userAuthentication",
                {
                    number: values.phone,
                    otp: "",
                    deviceType: "WEB",
                    deviceID: "unique_device_id",
                    deviceToken: "token_here",
                }
            );

            if (response.data.status) {
                alert("OTP resent successfully!");
                setResendTimer(30);
            } else {
                alert("Failed to resend OTP. Please try again.");
            }
        } catch (error) {
            alert("An error occurred while resending the OTP.");
        }
    };

    // ✅ New helper: always focus the first empty box when clicked
    const handleClick = (e) => {
        const inputs = Array.from(textBase.current.childNodes);
        const firstEmpty = inputs.find((input) => input.value === "");
        if (firstEmpty) {
            firstEmpty.focus();
            e.preventDefault();
        }
    };

    return (
        <div>
            <section>
                <div className="container-xxl pl-0 pt-[20px]">
                    <div className="row">
                        <div className="col-12 flex items-center justify-center">
                            <div className="md:w-[900px] w-full flex h-[541px] ">
                                <div className="w-full md:block hidden">
                                    <img
                                        src="/assates/Login.png"
                                        className="h-full w-full"
                                    />
                                </div>
                                <div className="w-full md:shadow-xl md:p-4 rounded-br-xl rounded-tr-xl">
                                    <div className="md:p-[50px] p-0">
                                        <div className="flex items-center justify-center">
                                            <img
                                                src="/assates/Logo__newimage-removebg-preview.png"
                                                className="w-[200px] rounded-lg"
                                            />
                                        </div>
                                        <h1 className="text-center Header__text font-[700]">
                                            OTP Verification
                                        </h1>
                                        <p className="text-center Paragraph__etxt font-[500] pb-12">
                                            Please enter the OTP sent to your phone to continue.
                                        </p>

                                        <div
                                            className="otp-base flex justify-between"
                                            ref={textBase}
                                        >
                                            {new Array(6).fill(null).map((_, index) => (
                                                <input
                                                    key={index}
                                                    type="number"
                                                    maxLength="1"
                                                    onChange={(e) => focusNext(e)}
                                                    onKeyDown={(e) => focusNext(e)}
                                                    onClick={handleClick} // ✅ added click handler
                                                    className="otp-input md:w-[50px] w-full h-[40px] text-center text-[20px] bg-transparent border-b-2 border-[#B4B4B4] "
                                                    style={{ outline: "none" }}
                                                />
                                            ))}
                                        </div>

                                        <form onSubmit={handleNextStep}>
                                            <button
                                                type="submit"
                                                className={`mt-8 w-full flex items-center hover:bg-black bg-[#28282B] text-white gap-2 Paragraph__etxt font-[500] h-[50px] justify-center choose_qulifation_section rounded-lg ${
                                                    verified ? "bg-green-500" : ""
                                                }`}
                                            >
                                                <label>Verify OTP</label>
                                            </button>
                                        </form>

                                        {verified && (
                                            <p className="text-center text-green-500 mt-4">
                                                OTP Verified Successfully!
                                            </p>
                                        )}

                                        <a
                                            href="#"
                                            onClick={clearAll}
                                            className="mt-4 inline-block text-red-500 hover:underline cursor-pointer"
                                        >
                                            Clear OTP
                                        </a>

                                        <div className="mt-2 text-center">
                                            {resendTimer > 0 ? (
                                                <span className="text-gray-500">
                                                    Resend OTP in {resendTimer}s
                                                </span>
                                            ) : (
                                                <a
                                                    href="#"
                                                    onClick={resendOtp}
                                                    className="text-blue-500 hover:underline"
                                                >
                                                    Resend OTP
                                                </a>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default LoginThreeOtp;
